<template>
  <div class="status-label">
    <StatusIndicator :color="statusColor" /> {{ status }} 
  </div>
</template>

<script>
import { computed } from 'vue'
import StatusIndicator from './StatusIndicator.vue'

export default {
  components: { StatusIndicator },
  props: {
    status: {
      type: String,
      required: true
    }
  },

  setup(props) {

    const statusColor = computed(() => {
      if (props.status === "Afvist") {
        return "#dc3545";
      } else if (props.status === "Indsendt") {
        return "#ffc107";
      } else if (props.status === "Godkendt") {
        return "#28a745";
      }

      return "transparent";
    });

    return {
      statusColor
    };
  }
}
</script>

<style lang="scss" scoped>
.status-label{
  display: flex;
  align-items: center;
}
</style>